import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="payment-methods"
export default class extends Controller {
  static targets = ["overlay", "expiration", "number"];
  
  currentExpiration; 
  errorMessage;

  connect() {
    this.currentExpiration = ""
    const errorElm = this.element.querySelector("#cc_error")
    if (errorElm) {
      this.errorMessage = errorElm.innerHTML
      if (this.errorMessage) {
        this.show()
      }
    }
  }

  show() {
    this.overlayTarget.classList.remove("hidden")
  }

  hide() {
    this.overlayTarget.classList.add("hidden")
  }

  formatExpiration() {
    const newValue = this.expirationTarget.value
    if (this.currentExpiration.includes("/") && !newValue.includes("/")) {
      this.expirationTarget.value = newValue
    } else if (!newValue.includes("/")) {
      if (newValue.length == 1 && parseInt(newValue) > 1) {
        this.expirationTarget.value = "0" + newValue + "/"
      } else if (newValue.length == 2 && parseInt(newValue) < 13) {
        this.expirationTarget.value = newValue + "/"
      } 
    }

    this.currentExpiration = this.expirationTarget.value
  }

  formatNumber() {
    var value = this.numberTarget.value
    var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
    var matches = v.match(/\d{4,16}/g)
    var match = matches && matches[0] || ''
    var parts = []

    var i, len;
    for (i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i+4))
    }

    var newValue;
    if (parts.length) {
        newValue = parts.join(' ')
    } else {
        newValue = value
    }

    this.numberTarget.value = newValue

  }
}
